
import { p2PhaseStudyList } from 'constants/globalEnum';
import { statusLookup, NA } from 'utility/lookup';
import { typeOfReview } from 'constants/globalEnum';

export const BASIC = 'basic';
export const ADVANCED = 'advanced';

export const searchDocTypeEnum = {
    INIT_APPLICATION: 'INIT_APPLICATION',
    PROGRESS_REPORT: 'PROGRESS_REPORT',
    LOCAL_SAE_REPORT: 'LOCAL_SAE_REPORT',
    SUSAR_REPORT: 'SUSAR_REPORT',
    PROTOCOL_DEVIATION_REPORT: 'PROTOCOL_DEVIATION_REPORT',
    MISCELLANEOUS_REPORT: 'MISCELLANEOUS_REPORT',
    PROTOCOL_AMENDMENT: 'PROTOCOL_AMENDMENT',
    CTC_CTI: 'CTC_CTI',
    FINAL_REPORT: 'FINAL_REPORT',
}

export const mapStatusLookup = () => {
    const temp = [];


    
    statusLookup.forEach((item) => {
        if (item.key !== NA) {
            temp.push({ ...item, label: item.statusDisplay })
        }
    })
    return temp;
};

export const mapP2PhaseStudyList = () => {
    return p2PhaseStudyList.map(item => {
        return { ...item, label: item.display };
    });
};

export const documentTypeList = [
    {
        key: searchDocTypeEnum.INIT_APPLICATION,
        label: 'Initial Application',
    },
    {
        key: searchDocTypeEnum.PROGRESS_REPORT,
        label: 'Progress Report',
    },
    {
        key: searchDocTypeEnum.LOCAL_SAE_REPORT,
        label: 'Local SAE Report',
    },
    {
        key: searchDocTypeEnum.SUSAR_REPORT,
        label: 'SUSAR Report',
    },
    {
        key: searchDocTypeEnum.PROTOCOL_DEVIATION_REPORT,
        label: 'Protocol Deviation Report',
    },
    {
        key: searchDocTypeEnum.MISCELLANEOUS_REPORT,
        label: 'Miscellaneous Report',
    },
    {
        key: searchDocTypeEnum.PROTOCOL_AMENDMENT,
        label: 'Amendment Application',
    },
    {
        key: searchDocTypeEnum.CTC_CTI,
        label: 'CTC/CTI Submission',
    },
    {
        key: searchDocTypeEnum.FINAL_REPORT,
        label: 'Final Report',
    },
];
export const typeofSponsoredStudyList = [
    {
        key: 'NO',
        label: 'No sponsor (Study Info Q18.3 = No)',
    },
    {
        key: 'Y',
        label: 'Commercial sponsored (Q18.3.1)',
    },
    {
        key: 'N',
        label: 'Non-commercial sponsored (Q18.3.1)',
    }
];
export const studentProjectList = [
    {
        key: 'Y',
        label: 'Yes'
    },
    {
        key: 'N',
        label: 'No'
    }
];

export const typeOfEthicsReviewList = typeOfReview.map(item => {
    item.label = item.display;
    return item;
});

export const indemnityList = [
    {
        key: 'Y',
        label: 'Yes'
    },
    {
        key: 'N',
        label: 'No'
    }
];
export const insuranceList = [
    {
        key: 'Y',
        label: 'Yes'
    },
    {
        key: 'N',
        label: 'No'
    }
];
export const CTCList = [
    {
        key: 'Y',
        label: 'Yes'
    },
    {
        key: 'N',
        label: 'No'
    }
];

export const applyingClusterList = [];

export const basicDefaultFormData = {
    documentType: {
        value: '',
        label: 'Document Type',
        name: 'documentType',
        type: 'select',
        operators: documentTypeList,
        groupType: 'basic',
        fieldName: 'docType',
        operatorType: 'EQ',
        validators: ['isRequired'],
    },
    applicationNo: {
        value: '',
        label: 'CRER Application No',
        name: 'applicationNo',
        type: 'input',
        groupType: 'basic',
        fieldName: 'appNo',
        operatorType: 'LIKE',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    submissionRefNo: {
        value: '',
        label: 'Submission Ref No.',
        name: 'submissionRefNo',
        type: 'input',
        groupType: 'basic',
        fieldName: 'subNo',
        operatorType: 'LIKE',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    IRBRECReferenceNo: {
        value: '',
        label: 'IRB/REC Ref No.',
        name: 'IRBRECReferenceNo',
        type: 'input',
        groupType: 'basic',
        fieldName: 'refNo',
        operatorType: 'LIKE',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    scientificTitle: {
        value: '',
        label: 'Scientific Title',
        name: 'scientificTitle',
        type: 'input',
        groupType: 'basic',
        fieldName: 'p1scientificTitle',
        operatorType: 'LIKE',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    coordinatorSurname: {
        value: '',
        label: 'Coordinating Investigator (Surname)',
        name: 'coordinatorSurname',
        type: 'input',
        hideInApplicant: true,
        groupType: 'basic',
        fieldName: 'surname',
        operatorType: 'EQ',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    coordinatorFirstName: {
        value: '',
        label: 'Coordinating Investigator (First Name)',
        name: 'coordinatorFirstName',
        type: 'input',
        hideInApplicant: true,
        groupType: 'basic',
        fieldName: 'firstName',
        operatorType: 'LIKE',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    coordinatorEmail: {
        value: '',
        label: 'Coordinating Investigator (Email)',
        name: 'coordinatorEmail',
        type: 'input',
        hideInApplicant: true,
        groupType: 'basic',
        fieldName: 'email',
        operatorType: 'EQ',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255,
        showErrorWhenOnBlur: true,
    },
}
export const advancedDefaultFormData = {
    submissionStartDate: {
        value: null,
        label: 'Submission Date (From)',
        name: 'submissionStartDate',
        type: 'date',
        groupType: 'advanced',
        fieldName: 'submissionDate',
        operatorType: 'GTE',
        maxDateField: 'submissionEndDate',
        localTime: true,
    },
    submissionEndDate: {
        value: null,
        label: 'Submission Date (To)',
        name: 'submissionEndDate',
        type: 'date',
        groupType: 'advanced',
        fieldName: 'submissionDate',
        operatorType: 'LTE',
        minDateField: 'submissionStartDate',
        localTime: true,
    },
    keywords: {
        value: '',
        label: 'Key Words',
        name: 'keywords',
        type: 'input',
        groupType: 'advanced',
        fieldName: 'p1keyWords',
        operatorType: 'LIKE',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    studyArticle: {
        value: '',
        label: 'Study Article',
        name: 'studyArticle',
        type: 'input',
        groupType: 'advanced',
        fieldName: 'p2studyArticle',
        operatorType: 'LIKE',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    nameOfSponsor: {
        value: '',
        label: 'Name of Sponsor',
        name: 'nameOfSponsor',
        type: 'input',
        groupType: 'advanced',
        fieldName: 'nameOfSponsor',
        operatorType: 'LIKE',
        isTrim: true,
        isNoSpace: true,
        validators: [],
        maxLength: 255
    },
    status: {
        value: '',
        label: 'Status',
        name: 'status',
        type: 'select',
        operators: mapStatusLookup(),
        groupType: 'advanced',
        fieldName: 'statusId',
        operatorType: 'EQ',
        isNoneSelect: true
    },
    applyingCluster: {
        value: '',
        label: 'Applying Cluster',
        name: 'applyingCluster',
        type: 'select',
        operators: applyingClusterList,
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'studyApplyingCluster',
        operatorType: 'EQ',
    },
    applyingHospital: {
        value: '',
        label: 'Applying Hospital',
        name: 'applyingHospital',
        type: 'hospitalOrInstitution',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'studyApplyingHospital',
        operatorType: 'EQ',
    },
    applyingDepartment: {
        value: '',
        label: 'Applying Department',
        name: 'applyingDepartment',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'studyApplyingDepart',
        operatorType: 'LIKE',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    reviewDecisionStartDate: {
        value: null,
        label: 'Review Decision Date (From)',
        name: 'reviewDecisionStartDate',
        type: 'date',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'decisionDate',
        operatorType: 'GTE',
        maxDateField: 'reviewDecisionEndDate',
        localTime: true,
    },
    reviewDecisionEndDate: {
        value: null,
        label: 'Review Decision Date (To)',
        name: 'reviewDecisionEndDate',
        type: 'date',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'decisionDate',
        operatorType: 'LTE',
        minDateField: 'reviewDecisionStartDate',
        localTime: true,
    },
    coordinatorCluster: {
        value: '',
        label: 'Coordinating Investigator(Cluster)',
        name: 'coordinatorCluster',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'cluster',
        operatorType: 'EQ',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    coordinatorHospitalInstitution: {
        value: '',
        label: 'CI (Hospital / Institution)',
        name: 'coordinatorHospitalInstitution',
        type: 'hospitalOrInstitution',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'institution',
        operatorType: 'EQ',
    },
    coordinatorDept: {
        value: '',
        label: 'Coordinating Investigator (Dept)',
        name: 'coordinatorDept',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'department',
        operatorType: 'LIKE',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    SitePISurname: {
        value: '',
        label: 'Site PI (Surname)',
        name: 'SitePISurname',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'pitSurname',
        operatorType: 'EQ',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    sitePIFirstName: {
        value: '',
        label: 'Site PI (First Name)',
        name: 'sitePIFirstName',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'pitFirstname',
        operatorType: 'LIKE',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    sitePIEmail: {
        value: '',
        label: 'Site PI (Email)',
        name: 'sitePIEmail',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'pitEmail',
        operatorType: 'EQ',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255,
        showErrorWhenOnBlur: true,
    },
    sitePICluster: {
        value: '',
        label: 'Site PI (Cluster)',
        name: 'sitePICluster',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'pitCluster',
        operatorType: 'EQ',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    sitePIHospitalInstitution: {
        value: '',
        label: 'Site PI (Hospital / Institution)',
        name: 'sitePIHospitalInstitution',
        type: 'hospitalOrInstitution',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'pitInstitution',
        operatorType: 'EQ',
    },
    sitePIDept: {
        value: '',
        label: 'Site PI (Dept)',
        name: 'sitePIDept',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'pitDepartment',
        operatorType: 'LIKE',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    CoSurname: {
        value: '',
        label: 'Co-investigator (Surname)',
        name: 'CoSurname',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'coiSurname',
        operatorType: 'EQ',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    CoFirstName: {
        value: '',
        label: 'Co-investigator (First Name)',
        name: 'CoFirstName',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'coiFirstname',
        operatorType: 'LIKE',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    CoEmail: {
        value: '',
        label: 'Co-investigator (Email)',
        name: 'CoEmail',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'coiEmail',
        operatorType: 'EQ',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255,
        showErrorWhenOnBlur: true,
    },
    CoHospitalInstitution: {
        value: '',
        label: 'Co-investigator (Hospital / Institution)',
        name: 'CoHospitalInstitution',
        type: 'hospitalOrInstitution',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'coiInstitution',
        operatorType: 'EQ',
    },
    CoDept: {
        value: '',
        label: 'Co-investigator (Dept)',
        name: 'CoDept',
        type: 'input',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'coiDepartment',
        operatorType: 'LIKE',
        validators: [],
        isTrim: true,
        isNoSpace: true,
        maxLength: 255
    },
    studentProject: {
        value: '',
        label: 'Student Project',
        name: 'studentProject',
        type: 'select',
        operators: studentProjectList,
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'student',
        operatorType: 'EQ',
        isBoolean: true,
    },
    phaseStudy: {
        value: '',
        label: 'Phase of Study',
        name: 'phaseStudy',
        type: 'select',
        operators: mapP2PhaseStudyList(),
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'p2PhaseStudy',
        operatorType: 'EQ',
    },
    typeOfEthicsReview: {
        value: '',
        label: 'Type of Ethics Review',
        name: 'typeOfEthicsReview',
        type: 'select',
        operators: typeOfEthicsReviewList,
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'typeOfReview',
        operatorType: 'EQ',
    },
    approvalExpiryStartDate: {
        value: null,
        label: 'Approval Expiry Date (From)',
        name: 'approvalExpiryStartDate',
        type: 'date',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'approvalExpiryDate',
        operatorType: 'GTE',
        maxDateField: 'approvalExpiryEndDate',
        localTime: true,
    },
    approvalExpiryEndDate: {
        value: null,
        label: 'Approval Expiry Date (To)',
        name: 'approvalExpiryEndDate',
        type: 'date',
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'approvalExpiryDate',
        operatorType: 'LTE',
        minDateField: 'approvalExpiryStartDate',
        localTime: true,
    },
    typeofSponsoredStudy: {
        value: '',
        label: 'Type of Sponsored Study',
        name: 'typeofSponsoredStudy',
        type: 'select',
        operators: typeofSponsoredStudyList,
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'p4SponsorType',
        operatorType: 'EQ',
    },
    indemnity: {
        value: '',
        label: 'Indemnity',
        name: 'indemnity',
        type: 'select',
        operators: indemnityList,
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'p4Indemnify',
        operatorType: 'EQ',
        isBoolean: true,
    },
    insurance: {
        value: '',
        label: 'Insurance',
        name: 'insurance',
        type: 'select',
        operators: insuranceList,
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'p4Insurance',
        operatorType: 'EQ',
        isBoolean: true,
    },
    CTC: {
        value: '',
        label: 'CTC',
        name: 'CTC',
        type: 'select',
        operators: CTCList,
        hideInApplicant: true,
        groupType: 'advanced',
        fieldName: 'p2CertificateCTC',
        operatorType: 'EQ',
        isBoolean: true,
    },
};